<template>
  <common-modal-section @close="clickedButton()" v-show="messageDialogStore.isVisible">
    <template v-slot:default>
      <modal-title-parts v-if="messageDialogStore.title" :title="messageDialogStore.title" />
      <modal-message-parts :message="messageDialogStore.message" />
      <modal-decline-message
        v-if="
          messageDialogStore.declineCode ||
          messageDialogStore.description ||
          messageDialogStore.nextUserAction
        "
        :declineCode="messageDialogStore.declineCode"
        :description="messageDialogStore.description"
        :nextUserAction="messageDialogStore.nextUserAction"
      />
      <modal-message-parts
        v-if="messageDialogStore.apiRequestErrorMessage"
        :message="messageDialogStore.apiRequestErrorMessage"
      />
      <div class="message-modal-section--content">
        <slot />
      </div>
    </template>

    <template v-slot:buttons>
      <atom-input-button
        :linkText="$t('common.ok')"
        colorType="secondary"
        :isDisabled="false"
        @push="clickedButton()"
      />
    </template>
  </common-modal-section>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import StoreUtil from '@/store/StoreUtil'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import ModalMessageParts from '@/components/common/modal/parts/ModalMessageParts.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import ModalDeclineMessage from '@/components/common/modal/parts/ModalDeclineMessageParts.vue'
/**
 * 共通メッセージダイアログのセクション
 */
export default defineComponent({
  name: 'MessageDialogSection',
  components: {
    CommonModalSection,
    ModalTitleParts,
    ModalMessageParts,
    AtomInputButton,
    ModalDeclineMessage,
  },
  setup() {
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')

    return {
      messageDialogStore,
    }
  },
  methods: {
    clickedButton(value: string) {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.messageDialogStore.close(value)
    },
  },
})
</script>

<style lang="scss" scoped>
.message-modal-section {
  &__content {
    font-size: 10px;
  }
}
</style>
